import { Box, Modal, Typography, useTheme, Grid } from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid';
import { customerComplaintConstants } from 'constants/constantText';
import { strings } from 'i18n/Strings';
import React from 'react';
import { colorTheme } from 'theme';
import { type IReuseGridProps } from 'types';

export interface IDialogProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children?: React.ReactNode;
  complaint?: ComplaintData | null; // modify type here
}

interface ComplaintData {
  agentId: number;
  complaintId: number;
  complaintTitle: string;
  createdAt: string;
  createdBy: number;
  description: string;
  email: string;
  firstName: string;
  imageUri: string;
  lastName: string;
  senderId: number;
  senderType: string;
  status: string;
  updatedAt: string;
  updatedBy: number;
  userId: number;
}

const ComplaintDetails = (props: IDialogProps): JSX.Element => {
  const { title, onClose, open, complaint } = props;
  const theme = useTheme();
  const colors = colorTheme(theme.palette.mode);

  const ReuseGrid = (props: IReuseGridProps): JSX.Element => (
    <Grid container item xs={12} sx={customStyles.gridStyle}>
      <Grid item xs={4} sx={customStyles.displayStyle}>
        <Typography>{props?.customName}</Typography>
      </Grid>
      <Grid item xs={4} sx={customStyles.subGridStyle}>
        <Typography>:</Typography>
      </Grid>
      <Grid item xs={4} sx={customStyles.subGridStyle}>
        <Typography>{props?.customerDetails}</Typography>
      </Grid>
    </Grid>
  );
  const customStyles = {
    gridStyle: {
      minHeight: '2rem',
    },
    boxStyle: {
      position: 'absolute' as const,
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',

      bgcolor: 'background.paper',
      boxShadow: 24,
      py: 2,
      px: 2,
      width: '35%',
      borderRadius: 5,
    },
    subBoxStyle: {
      display: 'flex',
      justifyContent: 'flex-end',
      cursor: 'pointer',
    },
    iconStyle: {
      bgcolor: colors.gray[900],
      borderRadius: 10,
    },
    titleStyle: {
      textAlign: 'center',
    },
    mbStyle: {
      display: 'flex',
      justifyContent: 'flex-end', // Corrected typo from 'sapece-between' to 'space-between'
    },
    maxWidthStyle: {
      maxWidth: '100%',
      maxHeight: '100%',
    },
    gridMarginBlockStyle: {
      marginBlock: '2%',
    },
    subGridStyle: {
      display: 'flex',
      justifyContent: 'center',
    },
    displayStyle: {
      display: 'flex',
    },
  };

  const complaintList = [
    customerComplaintConstants.complaintId,
    customerComplaintConstants.userId,
    customerComplaintConstants.firstName,
    customerComplaintConstants.lastName,
    customerComplaintConstants.email,
    customerComplaintConstants.status,
  ];

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={customStyles.boxStyle}>
        <Box onClick={onClose} sx={customStyles.subBoxStyle}>
          <GridCloseIcon sx={customStyles.iconStyle} />
        </Box>
        <Typography variant="h5" component="h2" sx={customStyles.titleStyle}>
          {title}
        </Typography>

        <Grid item xs={8} sx={customStyles.gridMarginBlockStyle}>
          {complaint && (
            <>
              {complaint &&
                Object.keys(complaint)?.map((ele, i) => {
                  if (complaintList.includes(ele)) {
                    return (
                      <div key={i}>
                        <ReuseGrid
                          customName={strings.displayText[ele]}
                          customerDetails={complaint[ele]}
                        />
                      </div>
                    );
                  }
                  return null;
                })}

              {/* {complaint?.imageUri && (
                <Grid
                  container
                  item
                  xs={12}
                  sx={{
                    minHeight: '5rem',
                  }}
                >
                  <Grid item xs={4} sx={customStyles.displayStyle}>
                    <Typography>{customerComplaintConstants.image}</Typography>
                  </Grid>
                  <Grid item xs={4} sx={customStyles.subGridStyle}>
                    <Typography>:</Typography>
                  </Grid>
                  <Grid item xs={4} sx={customStyles.subGridStyle}>
                    <img
                      src={`${String(process.env.REACT_APP_Image_Uri)}${
                        complaint.imageUri
                      }`}
                      alt="Image"
                      style={customStyles.maxWidthStyle}
                    />
                  </Grid>
                </Grid>
              )} */}
              {/* Above img code is commented out bcoz we removed the image upload in complaints - Mobile */}
            </>
          )}
        </Grid>
      </Box>
    </Modal>
  );
};

export default ComplaintDetails;
